import React, { useState } from 'react'
import { SwitcherProps } from './Switcher.props'
import {
  SwitcherCheckbox,
  SwitcherContainer,
  SwitcherLabel,
  SwitcherSpan,
} from './Switcher.styled'

const Switcher = ({ defaultChecked, onChange, disabled }: SwitcherProps) => {
  const [checked, setChecked] = useState<boolean>(defaultChecked || false)
  return (
    <SwitcherContainer>
      <SwitcherCheckbox
        id={`react-switch-new`}
        type="checkbox"
        disabled={disabled}
        checked={checked}
        onClick={() => {
          setChecked(!checked)
          onChange(!checked)
        }}
      />
      <SwitcherLabel htmlFor={`react-switch-new`} checked={checked}>
        <SwitcherSpan checked={checked} />
      </SwitcherLabel>
    </SwitcherContainer>
  )
}

export default Switcher
